import APP_ACTIONS from '../constants/app-actions';
import localStorageAPI from '../services/local-storage-api';

import order from './order';
import placedOrder from './placed-order';
import UserAPI from '../apis/user';

const user = {
    logout: () => (dispatch, getState) => {
        dispatch({
            type: APP_ACTIONS.LOGOUT,
        });
        dispatch({
            type: APP_ACTIONS.REMOVE_USER,
        });
        dispatch({
            type: APP_ACTIONS.CLEAR_WALLETS,
        });
        localStorageAPI.clear();

        dispatch(placedOrder.clearPlacedOrder());
        dispatch(order.clearOrder());
    },
    setAgeValid(ageValid, accessToken, locale) {
        return (dispatch, getState) => {
            UserAPI.setAccountAgeValid({ age_valid: ageValid }, accessToken)
                .then((response) => {
                    UserAPI.getUser({ token: accessToken, locale }).then((response) => {
                        dispatch({
                            type: APP_ACTIONS.USER,
                            payload: {
                                id: response.body.data.id,
                                ...response.body.data.attributes,
                            },
                        });
                        localStorageAPI.save(getState());
                    });
                });
        };
    },
};

export default user;



/** WEBPACK FOOTER **
 ** ./src/actions/user.js
 **/